import type { RootState } from '@core';
import type { AppRoute } from '../models/routes.type';

/**
 * Получить текущий шаг навигации
 */
export const getCurrentStep = (state: RootState) => state.navigation.currentStep;

/**
 * Получить список завершенных шагов
 */
export const getCompletedSteps = (state: RootState) => state.navigation.completedSteps;

/**
 * Проверить, доступен ли указанный шаг для перехода
 */
export const canAccessStep = (state: RootState, step: AppRoute) =>
  state.navigation.completedSteps.includes(step);

/**
 * Проверить, является ли указанный шаг текущим
 */
export const isCurrentStep = (state: RootState, step: AppRoute) =>
  state.navigation.currentStep === step;
